/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { ActionsTaskForm } from '../../../../../forms/ActionsTaskForm';
import { IMoveTaskProps } from './types';
import useOutsideClick from '../../../../../../../../utils/click.utils';

export const MoveTask: FunctionComponent<IMoveTaskProps> = ({ task }) => {
  const dispatch = useDispatch();

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskMove');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(clearTaskModalStatuses());
      dispatch(storeTaskModalStatus('taskMove'));
    }
  }, [dispatch, open]);

  // const handleClickOutside = () => {
  //   if (open) {
  //     dispatch(clearTaskModalStatuses());
  //   }
  // };
  // const ref = useOutsideClick(handleClickOutside);

  return (
    <div className={open ? 'dropdown opened' : 'dropdown'}>
      <a className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 dropdown-button" title="Move" onClick={toggle}>
        <i className="icon f-9 blueGray icon-upload mr-1" /> Move
      </a>
      <div
        className="dropdown-menu drop-right"
        style={{ right: 40, overflowY: 'unset', minHeight: 325, maxHeight: 'fit-content' }}
      >
        <div className="mini-popup" /*ref={ref}*/>
          <div className="mini-popup-header justify-end">
            <span className="close_mini_popup" onClick={toggle}>
              ×
            </span>
          </div>
          <div className="mini-popup-body">
            <div className="field-container custom-select smaller-select">
              <input type="hidden" />
              {open && <ActionsTaskForm task={task} move={true} onClick={toggle} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
